import {Component, OnInit} from '@angular/core';
import {ItemGLSetup} from '@model/ItemGLSetup';
import {State} from '@progress/kendo-data-query';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {StoreApGLXref} from '@model/StoreApGLXref';
import {StoreApGlXrefService} from '~/app/core/services/store-ap-gl-xref.service';
import {HomeOffice} from '@model/HomeOffice';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {UserService} from '~/app/core/services/user.service';
import {Router} from '@angular/router';
import {Store} from '@model/Store';
import {AuthServicesService} from 'mclane-webauth-lib';
import {StoreConfig} from '@model/StoreConfig';
import {StoreConfigService} from '~/app/core/services/store-config.service';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-store-ap-gl-xref',
  templateUrl: './store-ap-gl-xref.component.html',
  styleUrls: ['./store-ap-gl-xref.component.scss']
})
export class StoreApGlXrefComponent implements OnInit {
  public selectedHomeOffice: HomeOffice;
  public selectedStore: Store;
  public gridData: any = [];
  public mySelection: StoreApGLXref[] = [];
  public storeApGLXrefList: StoreApGLXref[] = [];
  public selectedCallback = (args) => args.dataItem;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 20
  };
  private editedRowIndex: number;
  private editedStore: StoreApGLXref;
  storeList: Store[] = [];
  selectedValue: Store;
  public minSegLength: number = 6;

  public storeConfigs: StoreConfig[] = [];
  public selectedStoreConfig: StoreConfig[];

  constructor(public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public authService: AuthServicesService,
              public router: Router,
              public localStorage: LocalStorageIndexedService,
              public storeApGlXrefService: StoreApGlXrefService,
              public storeConfigService: StoreConfigService) {
  }

  async ngOnInit() {
    this.loadingIndicator.show();
    this.localStorage.getFromSession(AppEnums.MIN_SEG_LENGTH);
    if (this.userService.selectedHomeOffice === undefined) {
      console.log("Trying to find the home office selected")
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.storeList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
        this.storeList.forEach(store => {
          store.display = store.chainID + ' - ' + store.storeID;
        });
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    } else {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.storeList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
      this.storeList.forEach(store => {
        store.display = store.chainID + ' - ' + store.storeID;
      });
      this.loadingIndicator.hide();
    }

    if (this.storeList.length > 0) {
      this.selectedValue = this.storeList[0];
      await this.storeValueChange(this.selectedValue);
    }
    this.loadingIndicator.hide();
  }

  async populateGrid(store: Store) {
    this.loadingIndicator.show();
    this.storeApGLXrefList = await this.storeApGlXrefService.getStoreApGlXrefList(store.hoID, store.chainID, store.storeID, this.authService.getUsername().toUpperCase());
    this.mySelection = [];
    this.gridData = this.storeApGLXrefList;
    this.gridData.total = this.storeApGLXrefList.length;
    this.loadingIndicator.hide();
  }

  public onStateChange(state: State) {
    this.gridState = state;
    //   this.storeApGlXrefService.read(this.selectedStore.hoID, this.selectedStore.chainID, this.selectedStore.storeID, this.authService.getUsername().toUpperCase());
  }

  public editHandler({sender, rowIndex, dataItem}) {
    // close the previously edited item
    this.closeEditor(sender);

    // track the most recently edited row
    // it will be used in `closeEditor` for closing the previously edited row
    this.editedRowIndex = rowIndex;

    // clone the current - `[(ngModel)]` will modify the original item
    // use this copy to revert changes
    this.editedStore = Object.assign({}, dataItem);

    // edit the row
    sender.editRow(rowIndex);
  }

  public addHandler({sender}, formInstance) {
    formInstance.reset();
    this.closeEditor(sender);
    sender.addRow(new ItemGLSetup());
  }

  public cancelHandler({sender, rowIndex}) {
    this.closeEditor(sender, rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    // close the editor
    grid.closeRow(rowIndex);

    // revert the data item to original state
    this.resetItem(this.editedStore);

    // reset the helpers
    this.editedRowIndex = undefined;
    this.editedStore = undefined;
  }

  resetItem(editedStore: StoreApGLXref) {
    if (!editedStore) {
      return;
    }

    // find orignal data item
    const originalDataItem = this.storeApGLXrefList.find(item => item.itemGLCode === editedStore.itemGLCode);

    // revert changes
    Object.assign(originalDataItem, editedStore);

    // super.next(this.storeApGLXrefList);
  }

  public saveHandler({sender, rowIndex, dataItem, isNew}) {
    console.warn({sender, rowIndex, dataItem, isNew});
    // update the data source

    if (dataItem.exportedGLCode !== null && dataItem.exportedGLCode.length === this.minSegLength || dataItem.exportedGLCode === '') {
      this.storeApGlXrefService.save(dataItem).subscribe(() => {
        this.populateGrid(this.selectedStore).then(r => r);
        this.editedStore = undefined;
        this.dialogService.showSuccessNotification('Update Successful');
      });
    } else {
      dataItem.exportedGLCode = '';
      this.dialogService.showErrorNotification('AP Export GL Code for item must be blank or ' + this.minSegLength + ' characters long. ');
    }

    // close the editor, that is, revert the row back into view mode
    sender.closeRow(rowIndex);
    this.closeEditor(sender);
  }


  public removeHandler({dataItem}) {
    this.dialogService.openDialog({
      type: DialogType.INFO,
      title: 'Available Exports',
      content: 'Are you sure you want to delete AP Export GL Code?',
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Ok', primary: true},
      ],
      width: 400
    }).then((answer) => {
      if (answer === 'Ok') {
        console.warn('guess i could use this??');
        console.warn(dataItem);
        this.storeApGlXrefService.delete(dataItem)
          .subscribe(() => {
            this.populateGrid(this.selectedStore).then(r => r);
            this.dialogService.showSuccessNotification('Delete Successful');
          });
      }
    });
  }

  async storeValueChange(store: Store) {
    this.selectedStore = store;
    // TODO call the segment API

    this.storeConfigs = await this.storeConfigService.getStoreConfig(store.hoID, this.authService.getUsername());
    this.selectedStoreConfig = this.storeConfigs.filter(store => store.store === this.selectedStore.storeID);
    let segments = this.selectedStoreConfig[0].segments;
    this.minSegLength = 0;
    segments.forEach(seg => {
      this.minSegLength = this.minSegLength + seg.length;
    });

    this.localStorage.setToSession(AppEnums.MIN_SEG_LENGTH, this.minSegLength);
    console.log('set to storage the minSegLength for Store AP GL XREF screen: ', this.minSegLength);

    this.populateGrid(store).then(r => r);
  }
}
